import { createContext, useContext } from 'react';
import { AISuggestedDocumentsResponse, SelectedProFormaOption, FieldPath } from './types';
import { InvestmentMemoNavItem } from './constants';

interface InvestmentMemoContextValue {
    documentSuggestions?: AISuggestedDocumentsResponse;
    isLoadingDocumentSuggestions: boolean;
    selectedProForma?: SelectedProFormaOption;
    isLoadingProForma?: boolean;

    // Validation
    shouldShowError: (fieldPath: FieldPath) => boolean;
    getFieldError: (fieldPath: FieldPath) => string | null;
    hasSectionError: (cardId: string) => boolean;
    hasNavError: (navItem: InvestmentMemoNavItem) => boolean;
}

export const InvestmentMemoContext = createContext<InvestmentMemoContextValue | null>(null);

export const useInvestmentMemoContext = () => {
    const ctx = useContext(InvestmentMemoContext);
    if (!ctx) throw new Error('useInvestmentMemoContext must be used within InvestmentMemoProvider');
    return ctx;
};
